export default function log (msg) {
  if (GV.config.debug) {
    console.log(msg)
  }
}




// WEBPACK FOOTER //
// ./F:/Development/geoviewer2/src/util/log.js